import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Buildings, CaretDown } from "@phosphor-icons/react";

// Admin "view as company" switcher. Master only. Scopes the WHOLE app (dashboard, people,
// employees, movement, etc.) to one company by sending X-Active-Store on every request.
// Empty value = All Companies (merged). Selection persists in localStorage.
export function CompanySelector() {
  const [stores, setStores] = useState([]);
  const [active, setActive] = useState(localStorage.getItem("sv_active_store") || "");

  useEffect(() => {
    api.get("/stores").then((r) => setStores(r.data || [])).catch(() => {});
  }, []);

  const onChange = (val) => {
    if (val) localStorage.setItem("sv_active_store", val);
    else localStorage.removeItem("sv_active_store");
    setActive(val);
    // Reload so every page re-fetches its data under the newly selected company scope.
    window.location.reload();
  };

  // Only real customer companies (flagged tenant) appear; fall back to all if none flagged.
  const tenants = stores.filter((s) => s.tenant);
  const shown = tenants.length ? tenants : stores;
  if (shown.length < 2) return null; // nothing to switch between

  return (
    <div className="flex items-center gap-2" data-testid="company-selector" title="View & analyze a specific company">
      <Buildings size={16} weight="bold" className="text-[#0A84FF] shrink-0" />
      <div className="relative">
        <select
          data-testid="company-selector-select"
          value={active}
          onChange={(e) => onChange(e.target.value)}
          className="appearance-none bg-[#141418] border border-white/15 text-white text-xs font-mono-data pl-3 pr-8 py-2 hover:border-[#0A84FF]/60 focus:border-[#0A84FF] focus:outline-none cursor-pointer min-w-[170px]"
        >
          <option value="">All Companies</option>
          {shown.map((s) => (
            <option key={s.id} value={s.id}>{s.name}</option>
          ))}
        </select>
        <CaretDown size={12} weight="bold" className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-[#71717A]" />
      </div>
    </div>
  );
}
